{
  "title": "Bibliotek",
  "featured_exercises": "Favoriter",
  "exercise_library": "Övningar",
  "add_featured_placeholder": "Dina favoriter kommer att dyka upp här",
  "no_exercises_found": "Inga övningar hittades.",
  "error_toggle_favorite": "Misslyckades med att uppdatera favoritstatus",
  "error_forbidden_account_sync": "Åtkomst nekad. Kontrollera att ditt konto är helt synkat."
}
